<template>
  <section class="institutional">
    <div class="container">
      <img :src="data.image" alt class="hide-mobile" />

      <div class="container-info align-right" style="max-width: 371px; width: 100%;">
        <div class="info-area" v-html="data.area" />
        <div class="info-title" v-html="data.title" style="width: 100%;" />
        <ul class="info-list">
          <li v-for="(item, index) in data.list" :key="index" style="list-style: none;">
            <span v-html="item.text" style="direction: ltr; unicode-bidi: embed;" />
          </li>
        </ul>
        <img :src="data.image" alt class="hide-desktop" />
        <span class="info-view-more" v-html="data.view_more" />
        <a class="button" target="_blank" :href="data.button_link">{{ data.button_text }}</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["data"],
};
</script>

<style lang="scss" src="./Institutional.scss" />